import { SvgIcon, type SvgIconProps } from './svgIcon'

export const BoosterIcon = ({
  width = 15,
  height = 15,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 16 14" {...props}>
    <circle cx="6" cy="6" r="6" fill="#F00028" />
    <g clipPath="url(#clip0_652_11152)">
      <path
        d="M7.63246 2.69699C7.70927 2.48294 7.65199 2.23295 7.49447 2.09545C7.33695 1.95796 7.12215 1.97045 6.97505 2.12357L3.64244 5.62345C3.51226 5.76095 3.46539 5.98125 3.52658 6.17499C3.58776 6.36874 3.74398 6.49998 3.91712 6.49998H5.36863L4.36754 9.30301C4.29073 9.51706 4.34801 9.76705 4.50553 9.90455C4.66305 10.042 4.87785 10.0295 5.02495 9.87643L8.35756 6.37655C8.48774 6.23905 8.53461 6.01875 8.47342 5.82501C8.41224 5.63126 8.25732 5.50158 8.08288 5.50158H6.63137L7.63246 2.69699Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_652_11152">
        <rect width="5" height="8" fill="white" transform="translate(3.5 2)" />
      </clipPath>
    </defs>
  </SvgIcon>
)
